// https://discourse.threejs.org/t/threejs-gltf-meshes-rendering-position-issue/59997/1

import { Canvas } from '@react-three/fiber'
import { Center, OrbitControls, AccumulativeShadows, RandomizedLight, useEnvironment, Environment } from '@react-three/drei'
import { EffectComposer, Bloom, N8AO, ToneMapping } from '@react-three/postprocessing'
import { ToneMappingMode } from 'postprocessing'
import { useControls } from 'leva'
import { Ring } from './IzzyRing'

/*
Model source processed with: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.16 public/izzy_ring_v2.glb --transform -o src/IzzyRing.js
*/

export default function App() {
  const { shadow, frame, diamonds, ringScale, ringYaw, ringPitch, ringRoll } = useControls('Ring Settings', {
    shadow: '#000000',
    frame: '#9d9d9d',
    diamonds: '#ffffff',
    ringScale: { value: 0.21, min: 0.1, max: 3, step: 0.01 },
    ringPitch: { value: 1.41, min: -Math.PI, max: Math.PI, step: 0.01 },
    ringYaw: { value: -0.0, min: -Math.PI, max: Math.PI, step: 0.01 },
    ringRoll: { value: 0.47, min: -Math.PI, max: Math.PI, step: 0.01 }
  }, { collapsed: true })
  const env = useEnvironment({ files: 'https://dl.polyhaven.org/file/ph-assets/HDRIs/hdr/1k/peppermint_powerplant_2_1k.hdr' })
  return (
    <Canvas shadows dpr={[1, 2]} gl={{ antialias: true }} camera={{ position: [-5, 5, 14], fov: 20 }}>
      <spotLight position={[10, 10, 10]} angle={0.15} penumbra={1} decay={0} intensity={Math.PI} />
      <group position={[0, -0.5, 0]}>
        <Center top position={[0, 0, 0]}>
          <Ring
            frame={frame}
            diamonds={diamonds}
            env={env}
            scale={ringScale}
            rotation={[ringPitch, ringYaw, ringRoll]}
          />
        </Center>
        <AccumulativeShadows temporal frames={100} color={shadow} opacity={1.05}>
          <RandomizedLight radius={5} position={[10, 5, -5]} />
        </AccumulativeShadows>
      </group>
      <OrbitControls enablePan={false} minPolarAngle={0} maxPolarAngle={Math.PI / 2.25} />
      <EffectComposer multisampling={8}>
        <N8AO aoRadius={0.15} intensity={4} distanceFalloff={2} />
        <Bloom luminanceThreshold={3.5} intensity={0.85} levels={9} mipmapBlur />
        <ToneMapping mode={ToneMappingMode.ACES_FILMIC} />
      </EffectComposer>
      <Environment map={env} background blur={1} />
    </Canvas>
  )
}
